export default "__VITE_ASSET__Bs2SgBfQ__"